import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import RenderAppBasedOnInternet from "./RenderAppBasedOnInternet";
import axios from "axios";
import { Amplify, Analytics } from "aws-amplify";
import {
  awsPinPointConfig,
  sessionConfig,
  pageOptions,
  initialisePinPointConfig,
} from "./pinpointConfig";
import { PrintProvider } from "./context/PrintContext";
// import { initialiseFullStoryConfig } from "./fullStoryConfig";
const root = ReactDOM.createRoot(document.getElementById("root"));

let getConfig = async () => {
  let result = await axios.get("/api/userauthservice/getconfig");
  initialisePinPointConfig(
    result.data.pinpoint.idpId,
    result.data.pinpoint.region,
    result.data.pinpoint.appId
  );
  // initialiseFullStoryConfig(result.data.fullStoryOrgID);
  Amplify.configure(awsPinPointConfig()["Auth"]);
  Amplify.configure(awsPinPointConfig()["Analytics"]);
  Analytics.autoTrack("session", sessionConfig);
  Analytics.autoTrack("pageView", pageOptions);
  return result.data;
};

getConfig().then(
  root.render(
    <BrowserRouter basename={`${process.env.PUBLIC_URL}`}>
      <PrintProvider>
        <RenderAppBasedOnInternet />
      </PrintProvider>
    </BrowserRouter>
  )
);
